import { graphql } from '@/graphql-setup'

export const SIDEBAR_QUERY = graphql(`
  query Sidebar(
    $workPeriodStartDate: DateTime!
    $filterEndDate: DateTime!
    $lastYear: DateTime!
    $canViewIssues: Boolean!
    $canViewAbsences: Boolean!
    $canViewInfringements: Boolean!
  ) {
    allIssues(
      closedAt_Isnull: true
      archivedAt_Isnull: true
      relatedInfringement: null
    ) @include(if: $canViewIssues) {
      totalUnresolvedCount
    }
    absenceCountByStatus(status: PENDING) @include(if: $canViewAbsences)
    unresolvedInfringementCount(infringementTimestampGte: $lastYear)
      @include(if: $canViewInfringements)
    workPeriodApprovalCount(
      datetimeStart: $workPeriodStartDate
      datetimeEnd: $filterEndDate
    )
    allFormTemplates(excludeArchived: true, onlyMenuShortcuts: true) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`)
